import { AdditionalInfoView } from '../types';
import { UnreadInfo } from '../hooks/use-additional-infos/types';

export enum CompareInfosResult {
    LEFT_OLDER = -1,
    EQUAL = 0,
    LEFT_NEWER = 1,
}

type ComparedInfo = AdditionalInfoView | UnreadInfo;

export const compareInfos = (left: ComparedInfo, right: ComparedInfo): CompareInfosResult => {
    return left.id < right.id
        ? CompareInfosResult.LEFT_OLDER
        : right.id < left.id
        ? CompareInfosResult.LEFT_NEWER
        : CompareInfosResult.EQUAL;
};

export const sortDirectives = {
    ASC: {
        getSortValue: (info: AdditionalInfoView) => info,
        comparator: compareInfos,
    },
    DESC: {
        getSortValue: (info: AdditionalInfoView) => info,
        comparator: (left: ComparedInfo, right: ComparedInfo) => compareInfos(right, left),
    },
};
